// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// import en from "./i18n-en.json";
// import de from "./i18n-de.json";

// i18n
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     resources: {
//       en: {
//         translation: en
//       },
//       de: {
//         translation: de
//       }
//     },
//     lng: "en", // default language
//     fallbackLng: "en", // fallback language
//     interpolation: {
//       escapeValue: false
//     }
//   });

// export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./i18n-en.json";
import de from "./i18n-de.json";
import cityRidesEN from "./i18n-cityRides-en.json";
import cityRidesDE from "./i18n-cityRides-de.json";
import airportTransferDE from "./i18n-airport-de.json";
import airportTransferEN from "./i18n-airport-en.json";
import viptransferDE from "./I18n-viptransfer-de.json";
import viptransferEN from "./I18n-viptransfer-en.json";
import businessTransferEN from "./i18n-businesstransfer-en.json";
import businessTransferDE from "./i18n-businesstransfer-de.json";
import baggageTransferEN from "./i18n-baggageTransfer-en.json";
import baggageTransferDE from "./i18n-baggageTransfer-de.json";
import petTransferEN from "./i18n-petTransfer-en.json";
import petTransferDE from "./i18n-petTransfer-de.json";
import tourEventTransferEN from "./i18n-tourEventTransfer-en.json";
import tourEventTransferDE from "./i18n-tourEventTransfer-de.json";
import patientTransferEN from "./i18n-patientTransfer-en.json"
import patientTransferDE from "./i18n-patientTransfer-de.json"
import aboutUsEN from "./i18n-aboutUs-en.json";
import aboutUsDE from "./i18n-aboutUs-de.json";
import companyTermAndConditionEN from "./i18n-companyTerms-en.json"
import companyTermAndConditionDE from "./i18n-companyTerms-de.json"
import agentTermAndConditionDE from "./i18n-agentTerms-de.json"
import agentTermAndConditionEN from "./i18n-agentTerms-en.json"
import servicesEN from "./i18n-services-en.json"
import servicesDE from "./i18n-services-de.json"
import empTermsAndConditionEN from "./i18n-empTermsAndCondition-en.json"
import empTermsAndConditionDE from "./i18n-empTermsAndCondition-de.json"



i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,        // all old keys, untouched
      cityRides: cityRidesEN,
      airportTransfer:airportTransferEN,
      vipTransfer:viptransferEN,
      businessTransfer:businessTransferEN,
      baggageTransfer:baggageTransferEN,
      petTransfer:petTransferEN,
      tourEventTransfer:tourEventTransferEN,
      patientTransfer:patientTransferEN,
      aboutUs:aboutUsEN,
      companyTermAndCondition:companyTermAndConditionEN,
      agentTermAndCondition:agentTermAndConditionEN,
      services:servicesEN,
      empTermsAndCondition:empTermsAndConditionEN,
    },
    de: {
      translation: de,
      cityRides: cityRidesDE,
      airportTransfer:airportTransferDE,
      vipTransfer:viptransferDE,
      businessTransfer:businessTransferDE,
      baggageTransfer:baggageTransferDE,
      petTransfer:petTransferDE,
      tourEventTransfer:tourEventTransferDE,
      patientTransfer:patientTransferDE,
      aboutUs:aboutUsDE,
      companyTermAndCondition:companyTermAndConditionDE,
      agentTermAndCondition:agentTermAndConditionDE,
      services:servicesDE,
      empTermsAndCondition:empTermsAndConditionDE,

    }
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

export default i18n;